import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import { RootContext } from 'src/context/rootContext'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'
import { getPetPhotoByType, isExpiringSoon } from 'src/utils'

import * as S from './styles'

const PurchasedPackages = ({ purchasedPackages, onPurchasedPackageSelect }) => {
  const router = useRouter()
  const context = useContext(RootContext)
  const { state: { scheduleBody, petsData } } = useServiceScheduleContext()

  const handlePurchasedPackageSelect = (purchasedPackageData) => {
    if (onPurchasedPackageSelect) {
      onPurchasedPackageSelect(purchasedPackageData, { router, context })
    }
  }

  const getPetPhoto = (purchasedPackageData) => {
    return petsData?.find(pet => pet.id === purchasedPackageData?.pet.id)?.photo
  }

  const getPackageDisplayName = (purchasedPackageData) => {
    return `Pacote de ${purchasedPackageData?.service?.linkedService?.name}`
  }

  const getPackageQuantityText = (purchasedPackageData) => {
    return `${purchasedPackageData?.service?.packageQuantity} ${purchasedPackageData?.service?.linkedService?.name}s`
  }

  const getPackageStatus = (packageData) => {
    if (packageData.status === 'UNDER_REVIEW') {
      return { label: 'Em análise', name: 'analysis' }
    }

    if (isExpiringSoon(packageData.expiresAt)) {
      return { label: 'Próximo do vencimento', name: 'expiringSoon' }
    }

    return null
  }

  return (
    <S.Container>
      <S.Title>Pacotes Contratados</S.Title>
      <S.PurchasedPackagesGrid>
        {[...purchasedPackages]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((purchasedPackageData) => {
            const status = getPackageStatus(purchasedPackageData)

            return (
              <S.PurchasedPackageCard
                active={status?.name !== 'analysis'}
                isSelected={scheduleBody?.purchasedPackageId === purchasedPackageData.id}
                key={purchasedPackageData.id}
                onClick={() => handlePurchasedPackageSelect(purchasedPackageData)}
              >
                <S.PurchasedPackagePetAndStatusInfo>
                  <S.PetContainer>
                    <S.PetPhoto
                      src={getPetPhoto(purchasedPackageData) || getPetPhotoByType(purchasedPackageData?.pet?.breed?.type)}
                      setDefaultPhoto={!purchasedPackageData?.pet?.photo}
                      size='64px'
                      mobileSize='64px'
                    />
                    <S.PetInfo>
                      <S.PetName>{purchasedPackageData?.pet?.name}</S.PetName>
                      <S.PurchasedPackageDescription>{purchasedPackageData?.pet?.breed?.name}</S.PurchasedPackageDescription>
                    </S.PetInfo>
                  </S.PetContainer>
                  {status && (
                    <S.StatusBadge status={status.name}>
                      {status.label}
                    </S.StatusBadge>
                  )}
                </S.PurchasedPackagePetAndStatusInfo>
                <S.PurchasedPackageInfo>
                  <S.PurchasedPackageName>{getPackageDisplayName(purchasedPackageData)}</S.PurchasedPackageName>
                  <S.PackageQuantity>{getPackageQuantityText(purchasedPackageData)}</S.PackageQuantity>
                </S.PurchasedPackageInfo>
              </S.PurchasedPackageCard>
            )
          })}
      </S.PurchasedPackagesGrid>
    </S.Container>
  )
}

export default PurchasedPackages
